export const mongoDeviceNameInfluxMap = (category: string) => {
  if (category.toLowerCase().includes('unitController'.toLowerCase())) {
    return 'unit';
  }

  if (category.toLowerCase().includes('siteController'.toLowerCase())) {
    return 'site';
  }

  return category;
};
